import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: null,
  innerCircle: [],
  innerCirclePagination: null,
  activityData: [],
  innerCircleData: null,
  innerCircleDetails: [],
  addUserData: null,
  circleListData: [],
  commentListData: [],
  globalListData: {},
  createInnerCircleSucceeded: false,
  innerFileUploadSuccess: false,
  isDeleteSuccess: false,
  isEditSuccess: false
};
const innerCircleSlice = createSlice({
  name: 'innerCircle',
  initialState,
  reducers: {
    innerCircleLoad(state) {
      state.isLoading = true;
    },
    innerCircleSuccess(state, action) {
      state.isLoading = false;
      state.innerCircle = action.payload;
    },
    innerCircleFail(state) {
      state.isLoading = false;
    },
    createActivityLoad(state) {
      state.isLoading = true;
    },
    createActivitySuccess(state, action) {
      state.isLoading = false;
      state.activityData = action.payload.data;
    },
    createActivityFail(state) {
      state.isLoading = false;
    },
    createInnerCircleLoad(state) {
      state.isLoading = true;
      state.createInnerCircleSucceeded = false;

    },
    createInnerCircleSuccess(state, action) {
      state.isLoading = false;
      state.createInnerCircleSucceeded = true;
      state.innerCircleData = action.payload.innerCircle;
    },
    createInnerCircleFail(state) {
      state.isLoading = false;
      state.createInnerCircleSucceeded = false;

    },
    getCircleListLoad(state) {
      state.isLoading = true;
    },
    getCircleListSuccess(state, action) {
      state.isLoading = false;
      state.circleListData = action.payload;
    },
    getCircleListFail(state) {
      state.isLoading = false;
    },
    innerCircleDetailLoad(state) {
      state.isLoading = true;
    },
    innerCircleDetailSuccess(state, action) {
      console.log("this is my inner circle Detail", action.payload);
      state.isLoading = false;
      state.innerCircleDetails = action.payload;
    },
    innerCircleDetailFail(state) {
      state.isLoading = false;
    },
    addUserinCircleLoad(state) {
      state.isLoading = true;
      state.innerFileUploadSuccess = false;
      state.createInnerCircleSucceeded = false;
    },
    addUserinCircleSuccess(state, action) {
      state.isLoading = false;
      state.createInnerCircleSucceeded = false;
      state.innerFileUploadSuccess = true
    },
    addUserinCircleFail(state) {
      state.isLoading = false;
      state.createInnerCircleSucceeded = false;
      state.innerFileUploadSuccess = false
    },
    addUserCircleLoad(state) {
      state.isLoading = true;
    },
    addUserCircleSuccess(state, action) {
      state.isLoading = false;

    },
    addUserCircleFail(state) {
      state.isLoading = false;
    },
    getCommentListLoad(state) {
      state.isLoading = true;
    },
    getCommentListSuccess(state, action) {
      state.commentListData = action.payload;
    },
    getCommentListFail(state) {
      state.commentListData = [];
      state.isLoading = true;
    },

    innerCircleGlobalListLoad(state) {
      state.isLoading = true;
    },
    innerCircleGlobalListSuccess(state, action) {
      state.isLoading = false;
      state.globalListData = action.payload;
    },
    innerCircleGlobalListFail(state) {
      state.isLoading = false;
    },
    deleteCircleLoad(state) {
      state.isLoading = true;
      state.isDeleteSuccess = false;
    },
    deleteCircleSuccess(state) {
      state.isLoading = false;
      state.isDeleteSuccess = true;
    },
    editCircleLoad(state) {
      state.isLoading = true;
      state.isEditSuccess = false;


    },
    editCircleSuccess(state) {
      state.isLoading = false;
      state.isEditSuccess = true;
    }

  }
});

export const {
  innerCircleLoad,
  innerCircleSuccess,
  innerCircleFail,
  createActivityLoad,
  createActivitySuccess,
  createActivityFail,
  createInnerCircleLoad,
  createInnerCircleSuccess,
  createInnerCircleFail,
  getCircleListLoad,
  getCircleListSuccess,
  getCircleListFail,
  innerCircleDetailLoad,
  innerCircleDetailSuccess,
  innerCircleDetailFail,
  addUserinCircleLoad,
  addUserinCircleSuccess,
  addUserinCircleFail,
  addUserCircleLoad,
  addUserCircleSuccess,
  addUserCircleFail,
  getCommentListLoad,
  getCommentListSuccess,
  getCommentListFail,
  innerCircleGlobalListLoad,
  innerCircleGlobalListSuccess,
  innerCircleGlobalListFail,
  deleteCircleLoad,
  deleteCircleSuccess,
  editCircleLoad,
  editCircleSuccess

} = innerCircleSlice.actions;

export default innerCircleSlice.reducer;
